<template>
  <v-data-table
    class="elevation-2 text-h6 text-black table__desing-general bordered-table main-table"
    fixed-header
    :items="items"
    :loading="loading"
    :headers="headers"
    hide-default-header
  >
    <template #header>
      <thead class="header-table gray-header">
        <tr>
          <th
            v-for="(item, index) in headers"
            :key="index"
            :colspan="item?.colspan || 0"
            class="pa-4 text-subtitle-2 text-black text-center font-weight-bold"
          >
            {{ item.text }}
          </th>
        </tr>
      </thead>
    </template>
    <template #[`item`]="{ item, index }">
      <tr v-if="item.message">
        <td :colspan="headers.length" class="pa-4">
          <v-icon>mdi-information</v-icon> Fecha de arribo no disponible.
        </td>
      </tr>
      <tr v-else>
        <td>
          <div class="d-flex justify-center pa-4">
            <b class="mr-auto">
              {{ index + 1 }}
            </b>
            <div class="mr-auto">
              {{ item.code }}
            </div>
          </div>
        </td>
        <td>
          {{ item.description }}
        </td>
        <template v-if="item.has_arrival_date">
          <td>{{ item.arrival_date }}</td>
          <td>{{ item.remaining_days | capitalizeFirstLetter }}</td>
        </template>
        <template v-else>
          <td
            colspan="2"
            style="background: #ffdddd 0% 0% no-repeat padding-box"
          >
            Fechas de arribo no disponibles (favor de contactar <br />
            a planeacionlogistica@iusa.com.mx)
          </td>
          <td></td>
        </template>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: 'UpcomingArrivalsTable',
    props: {
      items: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        headers: [
          {
            text: 'Código',
            value: 'code',
          },
          {
            text: 'Descripción',
            value: 'description',
          },
          {
            text: 'Fecha estimada de arribo',
            value: 'arrival_date',
            colspan: 2,
          },
        ],
      };
    },
  };
</script>
<style scoped src="@/assets/css/table.css"></style>
